import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { BellOff, BellRing, XCircle } from 'lucide-react';
import { notify } from '../../components/Notify';
import AuthShell from '../../components/AuthShell';
import { checkUnsubscribeApi, unsubscribeEmailApi, resubscribeEmailApi } from '../../api';

export default function DescadastrarEmail() {
    const [params] = useSearchParams();
    const uid = params.get('uid') || '';
    const sig = params.get('sig') || '';
    const [estado, setEstado] = useState('checking'); // checking|invalid|subscribed|unsubscribed
    const [email, setEmail] = useState('');
    const [enviando, setEnviando] = useState(false);

    useEffect(() => {
        let vivo = true;
        if (!uid || !sig) { setEstado('invalid'); return; }
        checkUnsubscribeApi({ uid, sig })
            .then((res) => {
                if (!vivo) return;
                if (!res?.data?.valid) { setEstado('invalid'); return; }
                setEmail(res.data.email || '');
                setEstado(res.data.unsubscribed ? 'unsubscribed' : 'subscribed');
            })
            .catch(() => { if (vivo) setEstado('invalid'); });
        return () => { vivo = false; };
    }, [uid, sig]);

    const descadastrar = async () => {
        setEnviando(true);
        try { await unsubscribeEmailApi({ uid, sig }); setEstado('unsubscribed'); }
        catch (err) { notify(err?.response?.data?.error || 'Não foi possível descadastrar.'); }
        finally { setEnviando(false); }
    };

    const reativar = async () => {
        setEnviando(true);
        try { await resubscribeEmailApi({ uid, sig }); setEstado('subscribed'); }
        catch (err) { notify(err?.response?.data?.error || 'Não foi possível reativar.'); }
        finally { setEnviando(false); }
    };

    if (estado === 'checking') {
        return <AuthShell><div className="ueb-auth-card pcenter"><span className="pspin" style={{ color: 'var(--p-accent)' }} /><p className="ueb-auth-sub" style={{ marginTop: 14 }}>Carregando…</p></div></AuthShell>;
    }

    if (estado === 'invalid') {
        return (
            <AuthShell>
                <div className="ueb-auth-card pcenter">
                    <div className="ueb-auth-ico is-danger"><XCircle size={40} /></div>
                    <h1>Link inválido</h1>
                    <p className="ueb-auth-sub">Este link de preferências de email não é válido ou expirou.</p>
                    <Link className="pbtn pbtn--ghost pbtn--block" to="/login">Ir para o login</Link>
                </div>
            </AuthShell>
        );
    }

    const desinscrito = estado === 'unsubscribed';
    return (
        <AuthShell>
            <div className="ueb-auth-card pcenter">
                <div className={`ueb-auth-ico ${desinscrito ? 'is-danger' : 'is-success'}`}>
                    {desinscrito ? <BellOff size={40} /> : <BellRing size={40} />}
                </div>
                <h1>{desinscrito ? 'Emails desativados' : 'Preferências de email'}</h1>
                <p className="ueb-auth-sub">
                    {desinscrito
                        ? <>Você não receberá mais emails em <strong>{email}</strong>. Mudou de ideia?</>
                        : <>Não quer mais receber nossos emails em <strong>{email}</strong>?</>}
                </p>
                {desinscrito ? (
                    <button className="pbtn pbtn--primary pbtn--block" onClick={reativar} disabled={enviando}>
                        {enviando ? <span className="pspin" /> : 'Voltar a receber emails'}
                    </button>
                ) : (
                    <button className="pbtn pbtn--danger pbtn--block" onClick={descadastrar} disabled={enviando}>
                        {enviando ? <span className="pspin" /> : 'Descadastrar meu email'}
                    </button>
                )}
                <p className="ueb-auth-foot"><Link className="plink" to="/login">Voltar ao login</Link></p>
            </div>
        </AuthShell>
    );
}
